import React from 'react';
import PropTypes from 'prop-types';

const DebugStateContext = React.createContext(undefined);
const DebugDispatchContext = React.createContext(undefined);

function init() {
  return {
    showDebugColors: false,
    showDebugContextData: false,
    showDevElements: false,
    showMeetingInformation: false,
  };
}

function reducer(state, action) {
  switch (action.type) {
    case 'toggleDebugColors': {
      return {
        ...state,
        showDebugColors: !state.showDebugColors,
      };
    }
    case 'toggleDevElements': {
      return {
        ...state,
        showDevElements: !state.showDevElements,
      };
    }
    case 'toggleMeetingInformation': {
      return {
        ...state,
        showMeetingInformation: !state.showMeetingInformation,
      };
    }
    case 'toggleDebugContextData': {
      return {
        ...state,
        showDebugContextData: !state.showDebugContextData,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
function DebugProvider({ children }) {
  const [state, dispatch] = React.useReducer(reducer, null, init);

  return (
    <DebugStateContext.Provider value={state}>
      <DebugDispatchContext.Provider value={dispatch}>
        {children}
      </DebugDispatchContext.Provider>
    </DebugStateContext.Provider>
  );
}
function useDebugState() {
  const context = React.useContext(DebugStateContext);

  if (context === undefined) {
    throw new Error('useDebugState must be used within a DebugProvider');
  }

  return context;
}

function useDebugDispatch() {
  const context = React.useContext(DebugDispatchContext);

  if (context === undefined) {
    throw new Error('useDebugDispatch must be used within a DebugProvider');
  }

  return context;
}

DebugProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export {
  DebugProvider,
  useDebugState,
  useDebugDispatch,
};
